// Typed wrapper around /api/cached_events.
// Wire shape is validated through the Zod schemas in ./schemas.
import { z } from "zod";
import { CachedEventSchema, type CachedEvent } from "./schemas";

export type { CachedEvent };

const CachedEventListSchema = z.array(CachedEventSchema);

export async function listCachedEvents(): Promise<CachedEvent[]> {
  const r = await fetch("/api/cached_events");
  if (!r.ok) throw new Error(`GET /api/cached_events failed: ${r.status}`);
  return CachedEventListSchema.parse(await r.json());
}

// Layer 2: trigger ingest for one cached event. On success the response
// body is the refreshed CachedEvent (status now "cached"). Throws
// Error(detail) on 4xx/5xx — the wizard re-fetches listCachedEvents
// after a failure so the row reflects any backend-side reclassification
// (e.g. 409 stale-cached, 502 NAS unreachable, 422 source-missing).
export async function ingestCachedEvent(eventId: string): Promise<CachedEvent> {
  const r = await fetch(`/api/cached_events/${eventId}/ingest`, {
    method: "POST",
  });
  if (!r.ok) {
    let detail = `POST /api/cached_events/${eventId}/ingest failed: ${r.status}`;
    try {
      const body = await r.json();
      if (body && typeof body.detail === "string") detail = body.detail;
    } catch {
      // body wasn't JSON; keep the generic message.
    }
    throw new Error(detail);
  }
  return CachedEventSchema.parse(await r.json());
}
